<template>
  <div>
    <b-badge
        v-show="voucher.Vid != null"
        variant="light-success"
        @click="OpenVoucher(voucher.Vid)"
        class="cursor-pointer"
    >
      {{ voucher.TravelName }} : [{{ voucher.Vid }}] {{ voucher.TravelWeekDay }}, {{ voucher.TravelDay }} - {{ voucher.PickupTime }}
    </b-badge>
  </div>
</template>

<script>
import Remark from '@/views/voucher/Remark'
import Cleave from 'vue-cleave-component'
import BCardCode from '@core/components/b-card-code'
import {
  BTable,
  BFormCheckbox,
  BBadge,
  BFormSelect,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BRow,
  BDropdown,
  BDropdownDivider,
  BDropdownForm,
  BDropdownGroup,
  BDropdownItem,
  BPopover,
  BTab,
  BTabs,
  BInputGroupPrepend,
  BInputGroupAppend,
  VBTooltip, BInputGroup, BSpinner, BFormDatepicker
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { VueAutosuggest } from 'vue-autosuggest'

export default {
  name: 'ConnectedVoucherBadge',
  computed: {
    make() {
      this.id = this.makeid(24);
    }
  },
  props: ['vData'],
  components: {
    BFormCheckbox,
    BTab,
    BTabs,
    BFormSelect,
    Cleave,
    BTable,
    Remark,
    BCardCode,
    VueAutosuggest,
    BPopover,
    BDropdown,
    BDropdownDivider,
    BDropdownForm,
    BDropdownGroup,
    BDropdownItem,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BBadge,
    BInputGroupPrepend,
    BInputGroupAppend,
    BSpinner,
    BFormDatepicker
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      id: this.makeid(48),
      voucher: {
        Vid: 0,
        PickupTime: '',
        TravelWeekDay: '',
        TravelName: '',
      }
    }
  },
  created() {
    this.voucher = this.vData;
  },
  methods: {
    makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    OpenVoucher(vid) {
      if(this.$route.name == "VoucherMask")
        this.$router.push({ name: 'Blank' })

      this.$nextTick(() => this.$router.push({
        name: 'VoucherMask',
        params: { id: vid }
      }))
    }
  }
}
</script>

<style scoped>
</style>
